import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Fill-1",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.4546 8.08944C15.021 12.9028 18.9067 16.8657 23.7076 17.5184C24.4052 17.6137 25.0939 17.6407 25.7646 17.6083C26.3759 17.5795 26.7967 18.1891 26.6294 18.777C25.2 23.8331 20.1905 27.3897 14.5104 26.541C9.89831 25.8505 6.14751 22.1016 5.45885 17.4878C4.60836 11.8078 8.16496 6.80204 13.223 5.36899C13.8163 5.20357 14.4187 5.62791 14.3899 6.24284C14.3611 6.84699 14.3827 7.46192 14.4546 8.08944Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMoon;
